import { Link } from "react-router-dom";
import { residentialServices } from "@/mocks/services";
import SectionHeading from "@/components/base/SectionHeading";
import TiltCard from "@/components/base/TiltCard";

export default function ServicesPreview() {
  const featured = residentialServices.slice(0, 6);
  return (
    <section className="px-4 md:px-8 py-16 sm:py-20 md:py-28 bg-background-50">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12 md:mb-16">
        <SectionHeading
          eyebrow="What I do"
          title={
            <>
              Everyday electrical work,
              <br />
              done <em className="not-italic text-accent-600">tidy and safe.</em>
            </>
          }
          intro="Homes, flats and small businesses across Islington. No confusing jargon, no surprise pricing."
        />
        <Link
          to="/services"
          className="group inline-flex items-center gap-2 self-start md:self-end px-5 py-3 rounded-full border border-background-300 text-foreground-800 text-sm font-semibold hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
        >
          See all services
          <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5"></i>
        </Link>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6" data-product-shop>
        {featured.map((s) => (
          <TiltCard key={s.id} className="rounded-2xl" rotation={6} scale={1.015}>
          <article
            className="group relative flex flex-col rounded-2xl overflow-hidden bg-background-100 border border-background-200 transition-colors duration-300 hover:border-background-300 h-full"
          >
            <div className="relative aspect-[4/3] overflow-hidden bg-background-200">
              <img
                src={s.image}
                alt={`${s.title} — local electrician service`}
                loading="lazy" decoding="async"
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute top-3 left-3 inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-background-50/90 backdrop-blur-sm text-[11px] text-foreground-800 uppercase tracking-[0.14em]">
                <i className={`${s.icon} text-accent-600`}></i>
                Residential
              </div>
              {s.from && (
                <div className="absolute top-3 right-3 px-3 py-1 rounded-full bg-primary-950 text-background-50 text-xs font-semibold">
                  From {s.from}
                </div>
              )}
            </div>
            <div className="p-5 flex-1 flex flex-col">
              <h3 className="text-lg font-heading font-semibold text-foreground-950">
                {s.title}
              </h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                {s.description}
              </p>
              <div className="mt-5 flex items-center justify-between">
                <Link
                  to="/book"
                  className="group/btn inline-flex items-center gap-1.5 text-sm font-semibold text-primary-800 hover:text-primary-950 transition-colors cursor-pointer whitespace-nowrap"
                >
                  Book this service
                  <i className="ri-arrow-right-line transition-transform group-hover/btn:translate-x-0.5"></i>
                </Link>
                <Link
                  to="/services"
                  aria-label={`Learn more about ${s.title}`}
                  className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 text-foreground-800 hover:bg-accent-500 hover:text-primary-950 transition-colors cursor-pointer"
                >
                  <i className="ri-arrow-right-up-line"></i>
                </Link>
              </div>
            </div>
          </article>
          </TiltCard>
        ))}
      </div>
    </section>
  );
}